import React, { useState, useEffect, useContext } from 'react'; 
import Select, { StylesConfig } from 'react-select'; 
import { AppContext } from '../../../../providers/appProvider';

const StatusDropdown = ({ container, containerService, isDisabled}) => {
  const [selectedOption, setSelectedOption] = useState(0);
  const [previousOption, setPreviousOption] = useState(0); // New state for previous status
  const { appState, app } = useContext(AppContext);

  const handleChange = selectedOption => {
    const newStatus = selectedOption.value;
    const oldStatus = previousOption; // Save the previous status

    setPreviousOption(selectedOption.value); // Update previous status before setting new one
    setSelectedOption(newStatus);

    const statusN = Number(newStatus); 
    const statusExistsInAlternative = appState.assign_container_statuses.some(status => status.id === statusN);

    if (statusExistsInAlternative) {
      containerService.updateStatus(container.id, statusN); 
    } else { 
      app.setError("Selected status is in alternative statuses");
      setSelectedOption(oldStatus); // Revert to previous status
    }
  };

  useEffect(() => {
    setSelectedOption(container.status_id);
    setPreviousOption(container.status_id); // Initialize previous status
  }, [container.status_id]);

  const options = appState.container_statuses;

  const dot = (color = 'transparent') => ({
    alignItems: 'center',
    color: 'var(--text-color)', 
    display: 'flex', 
    ':before': {
      backgroundColor: color,
      borderRadius: 10,
      content: '" "',
      display: 'block',
      marginRight: 4,
      minHeight: 10,
      minWidth: 10,
    },
  });

  const colourStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'white', 
      border: state.isFocused ? '1px solid var(--border-color)' : '1px solid var(--border-color)',  
      boxShadow: state.isFocused ? 'none' : 'none', 
      '&:hover': {
        border: state.isFocused ? '1px solid var(--border-color)' : '1px solid var(--border-color)',  
      }, 
      minHeight: "unset", 
      width: '100%', 
      height: '30px', 
      cursor: 'pointer',    
      borderRadius: '5px',  
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'rgb(148 163 184)',
      padding: '3px 3px 3px 0px',
      "svg": {
        width: '14px',
        height: '14px',
      }
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      let backgroundColor;
      let color;
      let cursor = isDisabled ? 'not-allowed' : 'pointer';

      if (isDisabled) {
        backgroundColor = undefined;
        color = '#ccc';
      } else if (isSelected) {
        backgroundColor = '#f1f1f1';
        color = undefined;
      } else if (isFocused) { 
        backgroundColor = '#f1f1f1';
        color = data.color;
      } else {
        backgroundColor = undefined;
        color = data.color;
      }

      return {
        ...styles,
        fontSize: '13px',
        padding: '5px 8px',
        alignItems: 'center',
        color: 'var(--text-color)', 
        display: 'flex', 
        ':before': { 
          backgroundColor: isSelected ? data.color : color, 
          borderRadius: 10,
          content: '" "',
          display: 'block',
          marginRight: 8,
          height: 10,
          width: 10,
        },
        backgroundColor: backgroundColor,
        cursor: cursor,
        ':active': {
          ...styles[':active'],
          backgroundColor: backgroundColor,
        },
      };
    },
    input: (styles) => ({ 
      ...styles, 
      ...dot(), 
      fontSize: '12px'
    }),
    valueContainer: (styles) => ({
      ...styles,
      padding: "1px 5px",  
    }),
    menu: (provided, state) => ({
      ...provided,
      zIndex: "2",
    }),
    placeholder: (styles) => ({ ...styles, ...dot('#ccc') }), 
    singleValue: (styles, { data }) => ({ ...styles, fontSize: '13px', color: 'var(--text-color) !important', ...dot(data.color) }),
  };

  return (
    <div> 
      <Select   
        styles={colourStyles}
        isSearchable={false} 
        onChange={handleChange}
        value={options.filter(option => option.value === selectedOption)}
        options={options}
        isDisabled={container.is_archive || container.is_deleted || isDisabled}
      />  
    </div>
  );
};

export default StatusDropdown;
